module.exports = __webpack_public_path__ + "static/media/city.e2acf797.jpg";